import { useReveal, Image, VideoLoop } from '@ccg/core';
import React$1 from 'react';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Grid$1 from '../Grid/Grid.js';
import Text$1 from '../../basics/Text/Text.js';
import Icon$1 from '../../basics/Icon/Icon.js';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import RevealBox$1 from '../RevealBox/RevealBox.js';
import SpecialHeadline$1 from '../SpecialHeadline/SpecialHeadline.js';
import StyledStage from './Stage.style.js';

const Stage = (_ref) => {
  let {
    variant,
    headline,
    image,
    loop,
    newsFormat,
    subline,
    postDate,
    video,
    excerpt,
    title,
    link,
    breadcrumbLink
  } = _ref,
      props = _objectWithoutProperties(_ref, ["variant", "headline", "image", "loop", "newsFormat", "subline", "postDate", "video", "excerpt", "title", "link", "breadcrumbLink"]);

  const [ref, isVisible] = useReveal();
  const hasMedia = Boolean(image || video);
  return /*#__PURE__*/React$1.createElement(StyledStage, _extends({
    ref: ref,
    hasMedia: hasMedia,
    hasPostDate: postDate,
    variant: variant,
    hasOnlyHeadline: !hasMedia && !subline && !excerpt
  }, props), /*#__PURE__*/React$1.createElement(Grid$1, null, /*#__PURE__*/React$1.createElement("div", {
    className: "stage__headline"
  }, breadcrumbLink && /*#__PURE__*/React$1.createElement("div", {
    className: "stage__backLink"
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({
    variant: "subline",
    noHover: true,
    transform: "uppercase"
  }, breadcrumbLink), /*#__PURE__*/React$1.createElement(Icon$1, {
    icon: "rightArrow",
    alignment: "left"
  }), breadcrumbLink.label)), newsFormat && /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "copyIntro",
    transform: "uppercase",
    as: "p",
    reveal: true,
    isVisible: isVisible,
    className: "stage__news-format"
  }, newsFormat), link ? /*#__PURE__*/React$1.createElement(Link$1, _extends({}, link, {
    noHover: true,
    variant: "headline",
    className: "stage__link"
  }), /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
    as: "h1",
    variant: "hero",
    reveal: true,
    isVisible: isVisible,
    text: headline || title
  })) : /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
    as: "h1",
    variant: "hero",
    reveal: true,
    isVisible: isVisible,
    text: headline || title
  })), image || video ? /*#__PURE__*/React$1.createElement("div", {
    className: "stage__image"
  }, /*#__PURE__*/React$1.createElement(RevealBox$1, {
    isVisible: isVisible,
    direction: "left"
  }, image && !video ? /*#__PURE__*/React$1.createElement(Image, {
    src: image.url || image.src,
    ratio: "16:9",
    srcset: image.srcset,
    alt: image.alt,
    sizes: "(min-width: 768px) 50vw, 75vw",
    lazy: true
  }) : null, video ? /*#__PURE__*/React$1.createElement(VideoLoop, {
    src: video.url,
    loop: loop,
    autoPlay: true
  }) : null)) : null, subline && /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
    variant: "copyIntro",
    as: "h2",
    reveal: true,
    isVisible: isVisible,
    className: "stage__subline",
    text: `${postDate ? `
                <time className="stage__post-date" dateTime={postDate}>
                  ${postDate} - 
                </time>` : ''} ${subline}`
  }), excerpt && /*#__PURE__*/React$1.createElement("div", {
    className: "stage__info"
  }, /*#__PURE__*/React$1.createElement(Text$1, {
    reveal: true,
    content: excerpt,
    className: "stage__excerpt"
  }))));
};

Stage.propTypes = {
  variant: PropTypes$1.oneOf('default', 'standard', 'home'),
  title: PropTypes$1.string.isRequired,
  headline: PropTypes$1.string.isRequired,
  image: PropTypes$1.shape({
    src: PropTypes$1.string,
    url: PropTypes$1.string,
    srcset: PropTypes$1.shape(),
    alt: PropTypes$1.string,
    width: PropTypes$1.number,
    height: PropTypes$1.number
  }),
  newsFormat: PropTypes$1.string,
  link: PropTypes$1.shape(),
  loop: PropTypes$1.bool,
  postDate: PropTypes$1.string,
  subline: PropTypes$1.string,
  video: PropTypes$1.shape({
    url: PropTypes$1.string
  }),
  excerpt: PropTypes$1.string,
  breadcrumbLink: PropTypes$1.shape()
};
Stage.defaultProps = {
  variant: 'default',
  image: undefined,
  newsFormat: null,
  loop: true,
  postDate: null,
  subline: null,
  video: null,
  excerpt: null,
  link: null,
  breadcrumbLink: null
};

export default Stage;
